import React, { FC, useCallback, useEffect } from 'react';
import { useFetch } from '../../shared';
import { Loading } from '../../shared/components';
import { meMapper } from '../../../config/api/models';
import apiRoutes from '../../../config/api/routes';
import { persistor } from 'src/modules/shared/store';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { logOff } from 'src/modules/shared/slices/logout/slice';
import { setUser } from 'src/modules/shared/slices/auth/entity/AuthSlice';

const AutoLoginApp: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const [meResponse, me] = useFetch(apiRoutes.me(), {
    method: 'GET',
    mapper: meMapper,
  });

  useEffect(() => {
    if (meResponse.initial && !user) me();
  }, [meResponse, me, user]);

  const handleLogout = useCallback(async () => {
    dispatch(logOff());
    await persistor.purge();
    return history.replace('/');
  }, [dispatch, history]);

  useEffect(() => {
    if (meResponse.success) {
      dispatch(setUser(user));
    }

    if (meResponse.error && meResponse.code === 401) {
      handleLogout();
    }
  }, [meResponse, handleLogout, dispatch, user]);

  return <Loading />;
};

export default AutoLoginApp;
